module.exports = __webpack_public_path__ + "static/media/YF64_1.7451d4d7.jpg";